import semver from "semver";

export function cleanVersion(v: string | null | undefined): string | null {
    if (!v) return null;
    const coerced = semver.coerce(v);
    return coerced ? coerced.version : null;
}

// Semver-aware "is current behind latest"; non-semver refs fall back to plain inequality.
export function behindLatest(current: string | null | undefined, latest: string | null | undefined): boolean {
    if (!current || !latest) return false;
    const c = cleanVersion(current);
    const l = cleanVersion(latest);
    if (c && l) return semver.lt(c, l);
    return current !== latest;
}

export function newerTags(tags: string[], current: string | null | undefined): string[] {
    const c = cleanVersion(current);
    if (!c) return tags;
    return tags.filter((tag) => {
        const t = cleanVersion(tag);
        return t !== null && semver.gt(t, c);
    });
}
